(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdk-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tcc-side-cart')) return;

    var nativeFetch = window.fetch.bind(window);
    var CART_RE = /\/cart\/(add|change|update|clear)(?:\.js|\.json)?(?:[?#]|$)/;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    var root = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };
    var isEditor = function () {
      return !!(window.Shopify && window.Shopify.designMode);
    };
    var cartType = function (url) {
      var m = String(url || '').match(CART_RE);
      return m ? m[1] : null;
    };
    var emit = function (type) {
      document.dispatchEvent(new CustomEvent('tcc:cart:external', { detail: { type: type } }));
    };

    /* Detect cart changes made by the theme or apps (fetch + XHR). Our own calls use nativeFetch. */
    if (!window.__tccSideCartPatched) {
      window.__tccSideCartPatched = true;

      window.fetch = function (input, init) {
        var promise = nativeFetch(input, init);
        var type = null;
        try {
          type = cartType(typeof Request !== 'undefined' && input instanceof Request ? input.url : input);
        } catch (e) {}
        if (type) {
          promise.then(function (res) { if (res.ok) emit(type); }, function () {});
        }
        return promise;
      };

      var xhrOpen = XMLHttpRequest.prototype.open;
      var xhrSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__tccCartType = cartType(url);
        return xhrOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var type = xhr.__tccCartType;
        if (type) {
          xhr.addEventListener('load', function () {
            if (xhr.status >= 200 && xhr.status < 300) emit(type);
          });
        }
        return xhrSend.apply(this, arguments);
      };
    }

    var editorOpen = false;

    class TccSideCart extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onExternal = this.onExternal.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onOpenRequest = () => this.open();
        this.onCloseRequest = () => this.close();
        this.onRefreshRequest = () => this.refresh().catch(() => {});
        this.onEditorSelect = (e) => { if (e.detail && e.detail.sectionId === this.sectionId) this.open(false); };
        this.onEditorDeselect = (e) => { if (e.detail && e.detail.sectionId === this.sectionId) this.close(); };
      }

      connectedCallback() {
        /* Live store: move the drawer to <body> so theme wrappers (footer group,
           transforms, content-visibility, z-index) can't affect it.
           In the Theme Editor it stays in place so section editing keeps working. */
        if (!isEditor() && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }

        this.sectionId = this.dataset.sectionId;
        this.panel = this.querySelector('[data-cd-panel]');
        this.content = this.querySelector('[data-cd-content]');
        this.toast = this.querySelector('[data-cd-toast]');
        this.openOnAdd = this.dataset.openOnAdd !== 'false';
        this.interceptForms = this.dataset.interceptForms !== 'false';
        this.triggers = (this.dataset.triggers || '').trim();
        this.countSelectors = (this.dataset.countSelectors || '').trim();
        this.extraSections = (this.dataset.extraSections || '').split(',').map((s) => s.trim()).filter(Boolean);
        this.queue = Promise.resolve();
        this.timers = {};
        this.failedGifts = new Set();
        this.state = {};
        this.syncing = false;
        this.pulseValue = null;

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocClick, true);
        document.addEventListener('submit', this.onSubmit, true);
        document.addEventListener('tcc:cart:external', this.onExternal);
        document.addEventListener('tcc:cart:open', this.onOpenRequest);
        document.addEventListener('tcc:cart:close', this.onCloseRequest);
        document.addEventListener('tcc:cart:refresh', this.onRefreshRequest);
        window.addEventListener('pageshow', this.onPageShow);

        if (isEditor()) {
          document.addEventListener('shopify:section:select', this.onEditorSelect);
          document.addEventListener('shopify:block:select', this.onEditorSelect);
          document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
        }

        this.afterRender(true);
        if (isEditor() && editorOpen) this.open(false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocClick, true);
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('tcc:cart:external', this.onExternal);
        document.removeEventListener('tcc:cart:open', this.onOpenRequest);
        document.removeEventListener('tcc:cart:close', this.onCloseRequest);
        document.removeEventListener('tcc:cart:refresh', this.onRefreshRequest);
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        Object.keys(this.timers || {}).forEach((k) => clearTimeout(this.timers[k]));
        if (this.panelAnim) this.panelAnim.cancel();
        clearTimeout(this.toastTimer);
        clearTimeout(this.externalTimer);
        this.stopPulse();
        document.documentElement.classList.remove('tcc-cd-locked');
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      /* ---------- Open / close ---------- */
      open(focus) {
        if (this.isOpen) return;
        this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('tcc-cd-locked');
        if (isEditor()) editorOpen = true;
        this.animateIn();
        this.startPulse();
        if (focus !== false) requestAnimationFrame(() => this.panel && this.panel.focus({ preventScroll: true }));
        document.dispatchEvent(new CustomEvent('tcc:cart:opened'));
      }

      animateIn() {
        if (!this.panel || typeof this.panel.animate !== 'function') return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.panelAnim) this.panelAnim.cancel();
        this.panelAnim = this.panel.animate(
          [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
          { duration: 350, easing: 'cubic-bezier(.25, 1, .5, 1)' }
        );
        var overlay = this.querySelector('.tcc-cd__overlay');
        if (overlay) overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 350, easing: 'ease' });
      }

      close() {
        if (!this.isOpen) return;
        if (this.panelAnim) {
          this.panelAnim.cancel();
          this.panelAnim = null;
        }
        this.classList.remove('is-open');
        document.documentElement.classList.remove('tcc-cd-locked');
        editorOpen = false;
        this.stopPulse();
        var lf = this.lastFocus;
        this.lastFocus = null;
        if (lf && typeof lf.focus === 'function' && document.contains(lf) && !this.contains(lf)) {
          lf.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('tcc:cart:closed'));
      }

      /* ---------- Network ---------- */
      sectionIds() {
        return [this.sectionId].concat(this.extraSections).slice(0, 5);
      }

      enqueue(fn) {
        var run = this.queue.then(fn, fn);
        this.queue = run.catch(() => {});
        return run;
      }

      async request(path, body) {
        var ids = this.sectionIds();
        var opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
        if (body instanceof FormData) {
          body.append('sections', ids.join(','));
          body.append('sections_url', window.location.pathname);
          opts.body = body;
        } else {
          opts.headers['Content-Type'] = 'application/json';
          opts.body = JSON.stringify(Object.assign({}, body, { sections: ids, sections_url: window.location.pathname }));
        }
        var res = await nativeFetch(root() + path, opts);
        var data = {};
        try { data = await res.json(); } catch (e) {}
        if (!res.ok) {
          var msg = typeof data.description === 'string' ? data.description : (typeof data.message === 'string' ? data.message : '');
          throw new Error(msg || 'Something went wrong. Please try again.');
        }
        this.applySections(data.sections);
        return data;
      }

      refresh() {
        var ids = this.sectionIds();
        return this.enqueue(async () => {
          var res = await nativeFetch(root() + '?sections=' + encodeURIComponent(ids.join(',')), {
            headers: { Accept: 'application/json' }
          });
          if (!res.ok) return;
          this.applySections(await res.json());
        });
      }

      /* ---------- Rendering ---------- */
      applySections(sections) {
        if (!sections) return;
        Object.keys(sections).forEach((id) => {
          var html = sections[id];
          if (!html) return;
          if (id === this.sectionId) {
            this.renderMain(html);
            return;
          }
          var target = document.getElementById('shopify-section-' + id) || document.getElementById(id);
          if (!target) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section');
          target.innerHTML = src ? src.innerHTML : doc.body.innerHTML;
        });
      }

      renderMain(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cd-content]');
        if (!next) return;

        var body = this.content.querySelector('[data-cd-body]');
        var scroll = body ? body.scrollTop : 0;
        var active = document.activeElement;
        var hadFocus = active && this.content.contains(active);
        var focusSel = null;
        if (hadFocus && active.dataset && active.dataset.cdAction) {
          var line = active.closest('[data-line-key]');
          if (line) {
            focusSel = '[data-line-key="' + CSS.escape(line.dataset.lineKey) + '"] [data-cd-action="' + active.dataset.cdAction + '"]';
          }
        }

        this.content.innerHTML = next.innerHTML;

        var newBody = this.content.querySelector('[data-cd-body]');
        if (newBody) newBody.scrollTop = scroll;
        if (hadFocus && this.isOpen) {
          var el = focusSel ? this.content.querySelector(focusSel) : null;
          (el || this.panel).focus({ preventScroll: true });
        }
        this.afterRender(false);
      }

      afterRender(initial) {
        var stateEl = this.content.querySelector('[data-cd-state]');
        try { this.state = stateEl ? JSON.parse(stateEl.textContent) : {}; } catch (e) { this.state = {}; }
        this.paintPulse();
        if (!initial) {
          this.updateCounts();
          document.dispatchEvent(new CustomEvent('tcc:cart:updated', { detail: { count: this.state.count } }));
        }
        this.syncGifts();
      }

      updateCounts() {
        if (!this.countSelectors || typeof this.state.count !== 'number') return;
        try {
          document.querySelectorAll(this.countSelectors).forEach((el) => {
            if (this.contains(el)) return;
            el.textContent = this.state.count;
            el.setAttribute('data-count', this.state.count);
          });
        } catch (e) {}
      }

      /* ---------- Free gifts (add/remove to match unlocked tiers) ---------- */
      async syncGifts() {
        if (this.syncing) return;
        this.syncing = true;
        try {
          for (var i = 0; i < 3; i++) {
            var gifts = (this.state && this.state.gifts) || {};
            var updates = gifts.updates || {};
            var add = (gifts.add || []).filter((it) => !this.failedGifts.has(it.id));
            if (Object.keys(updates).length) {
              await this.enqueue(() => this.request('cart/update.js', { updates: updates }));
              continue;
            }
            if (add.length) {
              try {
                await this.enqueue(() => this.request('cart/add.js', { items: add }));
              } catch (e) {
                add.forEach((it) => this.failedGifts.add(it.id));
              }
              continue;
            }
            break;
          }
        } catch (e) {
          /* fail silently, cart stays usable */
        } finally {
          this.syncing = false;
        }
      }

      /* ---------- Events inside drawer ---------- */
      onClick(e) {
        var el = e.target.closest('[data-cd-action]');
        if (!el || !this.contains(el)) return;
        var action = el.dataset.cdAction;

        if (action === 'close') {
          e.preventDefault();
          this.close();
          return;
        }

        var line = el.closest('[data-line-key]');
        if ((action === 'plus' || action === 'minus') && line) {
          var qty = Math.max(0, (parseInt(line.dataset.qty, 10) || 0) + (action === 'plus' ? 1 : -1));
          this.setQty(line, qty, false);
        } else if (action === 'remove' && line) {
          this.setQty(line, 0, true);
        } else if (action === 'upsell') {
          this.addUpsell(el);
        }
      }

      onChange(e) {
        var sel = e.target.closest && e.target.closest('[data-cd-upsell-variant]');
        if (!sel) return;
        var opt = sel.selectedOptions[0];
        var card = sel.closest('[data-cd-upsell]');
        if (!opt || !card) return;
        var price = card.querySelector('[data-cd-upsell-price]');
        var compare = card.querySelector('[data-cd-upsell-compare]');
        if (price) price.textContent = opt.dataset.price || '';
        if (compare) {
          compare.textContent = opt.dataset.compare || '';
          compare.hidden = !opt.dataset.compare;
        }
      }

      onKeydown(e) {
        if (!this.isOpen) return;
        if (e.key === 'Escape') {
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), (el) => el.offsetParent !== null);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        var current = document.activeElement;
        if (!this.panel.contains(current)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && (current === first || current === this.panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && current === last) {
          e.preventDefault();
          first.focus();
        }
      }

      setQty(line, qty, immediate) {
        var key = line.dataset.lineKey;
        line.dataset.qty = qty;
        var out = line.querySelector('[data-cd-qty]');
        if (out) out.textContent = qty;
        line.classList.add('is-busy');
        if (qty === 0) line.classList.add('is-removing');

        clearTimeout(this.timers[key]);
        this.timers[key] = setTimeout(() => {
          delete this.timers[key];
          this.enqueue(() => this.request('cart/change.js', { id: key, quantity: qty })).catch((err) => {
            this.showToast(err.message);
            this.refresh().catch(() => {});
          });
        }, immediate ? 0 : 350);
      }

      addUpsell(btn) {
        var card = btn.closest('[data-cd-upsell]');
        var select = card && card.querySelector('[data-cd-upsell-variant]');
        var id = Number(select ? select.value : btn.dataset.variantId);
        if (!id || btn.disabled) return;
        btn.disabled = true;
        if (card) card.classList.add('is-busy');
        this.enqueue(() => this.request('cart/add.js', { items: [{ id: id, quantity: 1 }] }))
          .catch((err) => this.showToast(err.message))
          .finally(() => {
            if (btn.isConnected) {
              btn.disabled = false;
              if (card) card.classList.remove('is-busy');
            }
          });
      }

      /* ---------- Page-level hooks ---------- */
      onDocClick(e) {
        if (!this.triggers || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var target = null;
        try {
          target = e.target.closest ? e.target.closest(this.triggers) : null;
        } catch (err) {
          this.triggers = '';
          return;
        }
        if (!target || this.contains(target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open();
      }

      onSubmit(e) {
        var form = e.target;
        if (!this.interceptForms || !(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add/.test(action) || form.hasAttribute('data-tcc-cd-skip') || this.contains(form)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.addFromForm(form, e.submitter);
      }

      async addFromForm(form, submitter) {
        if (form.dataset.tccBusy) return;
        var btn = submitter || form.querySelector('[type="submit"]');
        form.dataset.tccBusy = '1';
        if (btn) {
          btn.classList.add('tcc-cd-adding');
          btn.setAttribute('aria-busy', 'true');
        }
        var oldError = form.querySelector('.tcc-cd-form-error');
        if (oldError) oldError.remove();

        try {
          await this.enqueue(() => this.request('cart/add.js', new FormData(form)));
          if (this.openOnAdd) this.open();
        } catch (err) {
          var p = document.createElement('p');
          p.className = 'tcc-cd-form-error';
          p.setAttribute('role', 'alert');
          p.textContent = err.message;
          form.appendChild(p);
        } finally {
          delete form.dataset.tccBusy;
          if (btn) {
            btn.classList.remove('tcc-cd-adding');
            btn.removeAttribute('aria-busy');
          }
        }
      }

      onExternal(e) {
        if (e.detail && e.detail.type === 'add') this.pendingOpen = true;
        clearTimeout(this.externalTimer);
        this.externalTimer = setTimeout(() => {
          var shouldOpen = this.pendingOpen && this.openOnAdd;
          this.pendingOpen = false;
          this.refresh()
            .then(() => { if (shouldOpen) this.open(); })
            .catch(() => {});
        }, 60);
      }

      onPageShow(e) {
        if (e.persisted) this.refresh().catch(() => {});
      }

      /* ---------- Live pulse ---------- */
      startPulse() {
        var el = this.content.querySelector('[data-cd-pulse]');
        if (!el) return;
        this.stopPulse();
        var min = parseInt(el.dataset.min, 10) || 0;
        var max = parseInt(el.dataset.max, 10) || min;
        if (max < min) max = min;
        var seconds = Math.max(2, parseInt(el.dataset.interval, 10) || 6);
        var tick = () => {
          this.pulseValue = Math.floor(min + Math.random() * (max - min + 1));
          this.paintPulse();
        };
        if (this.pulseValue === null) tick();
        this.pulseTimer = setInterval(tick, seconds * 1000);
      }

      stopPulse() {
        clearInterval(this.pulseTimer);
        this.pulseTimer = null;
      }

      paintPulse() {
        if (this.pulseValue === null) return;
        var el = this.content.querySelector('[data-cd-pulse-count]');
        if (el) el.textContent = this.pulseValue;
      }

      showToast(message) {
        if (!this.toast) return;
        this.toast.textContent = message || 'Something went wrong. Please try again.';
        this.toast.hidden = false;
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => { this.toast.hidden = true; }, 4000);
      }
    }

    customElements.define('tcc-side-cart', TccSideCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdk-home-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cdk-banner-glows')) {
    customElements.define('cdk-banner-glows', class CdkBannerGlows extends HTMLElement {
      connectedCallback() {
        this.glows = Array.from(this.querySelectorAll('.cdk-home-banner__glow'));
        this.timers = new Map();
        if (this.dataset.animate !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const css = getComputedStyle(this);
        this.cycle = (parseFloat(css.getPropertyValue('--banner-glow-speed')) || 14) * 1000;
        this.base = parseFloat(css.getPropertyValue('--banner-glow-opacity')) || 0.18;

        this.glows.forEach((glow) => {
          glow.classList.add('is-animated');
          this.move(glow, true);
          // Stagger the first move so the glows never travel in sync
          this.schedule(glow, Math.random() * this.cycle * 0.5);
        });
      }

      disconnectedCallback() {
        this.timers.forEach(clearTimeout);
        this.timers.clear();
      }

      schedule(glow, delay) {
        this.timers.set(glow, setTimeout(() => {
          const duration = this.cycle * (0.7 + Math.random() * 0.6);
          glow.style.transitionDuration = duration + 'ms';
          this.move(glow, false);
          this.schedule(glow, duration);
        }, delay));
      }

      move(glow, instant) {
        const w = this.clientWidth;
        const h = this.clientHeight;
        const size = glow.offsetWidth || 300;
        // Allow glows to drift slightly past the edges so they fade in and out naturally
        const x = Math.random() * (w - size * 0.4) - size * 0.3;
        const y = Math.random() * (h - size * 0.4) - size * 0.3;
        const scale = 0.7 + Math.random() * 0.7;
        const opacity = this.base * (0.45 + Math.random() * 0.75);

        if (instant) glow.style.transitionDuration = '0ms';
        glow.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px) scale(' + scale.toFixed(2) + ')';
        glow.style.opacity = opacity.toFixed(3);
      }
    });
  }

  /* Add to cart button. Without JS the form still posts to /cart/add normally. */
  if (!customElements.get('cdk-banner-atc')) {
    customElements.define('cdk-banner-atc', class CdkBannerAtc extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.labelEl = this.querySelector('.cdk-home-banner__button-label');
        this.errorEl = this.querySelector('.cdk-home-banner__atc-error');
        if (!this.form || !this.button) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        clearTimeout(this.resetTimer);
      }

      root() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-busy') === 'true') return;

        this.setError('');
        this.button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(this.root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(this.form.querySelector('[name="id"]').value),
                quantity: Number(this.form.querySelector('[name="quantity"]').value) || 1
              }]
            })
          });

          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

          this.afterAdd(data);
        } catch (error) {
          this.setError(error.message);
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }

      afterAdd(data) {
        const action = this.dataset.afterAdd || 'cart';

        if (action === 'checkout') {
          window.location.href = this.root() + 'checkout';
          return;
        }

        if (action === 'cart') {
          window.location.href = this.root() + 'cart';
          return;
        }

        // Stay on page: tell the theme / cart drawer the cart changed
        const eventName = (this.dataset.cartEvent || '').trim();
        if (eventName) document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: data }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));

        this.showAdded();
      }

      showAdded() {
        const added = this.dataset.addedLabel;
        if (!added || !this.labelEl) return;

        if (!this.originalLabel) this.originalLabel = this.labelEl.textContent;
        this.labelEl.textContent = added;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.labelEl.textContent = this.originalLabel;
        }, 2500);
      }

      setError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdk-how-to-use"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cdk-how-to-use')) {
    customElements.define('cdk-how-to-use', class CdkHowToUse extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.cdk-htu__lightbox');
        this.image = this.dialog ? this.dialog.querySelector('.cdk-htu__lightbox-image') : null;
        this.onClick = this.onClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.addEventListener('click', this.onClick);
        if (this.dialog) this.dialog.addEventListener('close', this.onClose);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.dialog) this.dialog.removeEventListener('close', this.onClose);
      }

      onClick(event) {
        if (!this.dialog || !this.image) return;

        const trigger = event.target.closest('[data-cdk-zoom]');
        if (trigger) {
          this.lastTrigger = trigger;
          this.image.src = trigger.dataset.src;
          this.image.alt = trigger.dataset.alt || '';
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            window.open(trigger.dataset.src, '_blank');
          }
          return;
        }

        // Close on the X button or a click on the backdrop
        if (event.target === this.dialog || event.target.closest('[data-cdk-close]')) {
          this.dialog.close();
        }
      }

      onClose() {
        if (this.image) this.image.removeAttribute('src');
        if (this.lastTrigger) this.lastTrigger.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
